module.exports = __webpack_public_path__ + "static/img/ios.7c8fc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/ios.png
// module id = Fr9Y
// module chunks = 1